/*
 * Copyright (c) 2019-2022 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import {
  hadNativeJoinSuccessInPast,
  wasNativeApplicationUsedInTheLast30Days,
} from './nativeUsageStore';

export const isFirstTimeUser = () =>
  !hadNativeJoinSuccessInPast() && !wasNativeApplicationUsedInTheLast30Days();
export const isFrequentUser = () =>
  hadNativeJoinSuccessInPast() && wasNativeApplicationUsedInTheLast30Days();
export const isInfrequentUser = () =>
  hadNativeJoinSuccessInPast() && !wasNativeApplicationUsedInTheLast30Days();

export enum UserType {
  FirstTime = 'triggerJoinPageWebFirstTimeUser',
  Frequent = 'triggerJoinPageWebFrequentUser',
  Infrequent = 'triggerJoinPageWebInfrequentUser',
  Undefined = 'triggerJoinPageWeb',
}

export const getUserType = () => {
  if (isFirstTimeUser()) {
    return UserType.FirstTime;
  } else if (isFrequentUser()) {
    return UserType.Frequent;
  } else if (isInfrequentUser()) {
    return UserType.Infrequent;
  } else {
    return UserType.Undefined;
  }
};
